import styled from 'styled-components'

export const VendorLogoBadgeLayoutStyled = styled.div`
  display: inline-block;
  flex-shrink: 0;
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(2)} ${props.theme.space.small}`};
  border: ${(props) => props.theme.typography.pxToRem(1)} solid
    ${(props) => props.theme.colors.badge.neutral.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};
  background: ${(props) => props.theme.colors.white};
  overflow: hidden;
`
